module.exports = __webpack_public_path__ + "img/h2.8dc4812f.png";